export const smsOrganisationDocuments = [
  {
    name: "Franchise Agreement",
    value: "sponsorAppDocs:priDoc:2:provideSingle",
  },
  {
    name: "Digitech declaration",
    value: "sponsorAppDocs:priDoc:3:provideSingle",
  },
];

export const smsCharityOptions = [
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Registered",
    value: "REGD",
  },
  {
    name: "Excepted",
    value: "EXCPT",
  },
  {
    name: "Exempt",
    value: "EXMPT",
  },
  {
    name: "Based in NI",
    value: "BASENI",
  },
  {
    name: "Ecclesiastical corporation",
    value: "ECCLCORP",
  },
  {
    name: "None of the above (Please see guidance)",
    value: "NONE",
  },
];

export const smsOtherDocuments = [
  {
    name: "Supporting Letter from Bank Manager",
    value: "sponsorAppDocs:secDoc:0:provideSingle",
  },
  {
    name: "Sup. let. UK Trade and Investments",
    value: "sponsorAppDocs:secDoc:1:provideSingle",
  },
  {
    name: "HMRC - Self Asses. (SA300 or SA302)",
    value: "sponsorAppDocs:secDoc:2:provideSingle",
  },
  {
    name: "HMRC Reg - VAT",
    value: "sponsorAppDocs:secDoc:3:provideSingle",
  },
  {
    name: "HMRC Reg-PAYE Ref No/Acc Off Ref No",
    value: "sponsorAppDocs:secDoc:4:provideSingle",
  },
  {
    name: "Proof of Bus Prem/Fxd Assets/Lease",
    value: "sponsorAppDocs:secDoc:5:provideSingle",
  },
  {
    name: "HMRC - Self Emp. - Uniq. Tax Ref.",
    value: "sponsorAppDocs:secDoc:6:provideSingle",
  },
  {
    name: "Corp/Business Bank Statement OR Letter from bank",
    value: "sponsorAppDocs:secDoc:7:provideSingle",
  },
];

export const smsTitleOptions = [
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Miss",
    value: "MIS ",
  },
  {
    name: "Mr",
    value: "MR  ",
  },
  {
    name: "Mrs",
    value: "MRS ",
  },
  {
    name: "Ms",
    value: "MS  ",
  },
  {
    name: "Mx",
    value: "MX  ",
  },
  {
    name: "Dr",
    value: "DR  ",
  },
  {
    name: "Other",
    value: "ZZ  ",
  },
];

export const smsOrganisationTradingPeriod = [
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "0 to 6 months",
    value: "1",
  },
  {
    name: "Over 6 to 12 months",
    value: "2",
  },
  {
    name: "Over 12 to 18 months",
    value: "3",
  },
  {
    name: "Over 18 to 36 months",
    value: "4",
  },
  {
    name: "Over 36 months+",
    value: "5",
  },
];

export const smsTypeOfOrganisation = [
  // {
  //   name: "- Select -",
  //   value: null,
  // },
  // {
  //   name: "Branch Office of an Overseas Company",
  //   value: "BOOC",
  // },
  // {
  //   name: "Central/local Gov. Dept; Body; Quango, Agency Public Body",
  //   value: "GDQA",
  // },
  // {
  //   name: "Charity",
  //   value: "CHAR",
  // },
  // {
  //   name: "Company limited by Guarantee",
  //   value: "CLG ",
  // },
  // {
  //   name: "Co Inc under the Industrial & Provident Societies Act 1968",
  //   value: "IPSA",
  // },
  // {
  //   name: "Hotel and/or Catering Establishment",
  //   value: "HOCA",
  // },
  // {
  //   name: "Incorporated by Royal Charter",
  //   value: "IBRC",
  // },
  // {
  //   name: "Limited Liability Partnership",
  //   value: "LLP ",
  // },
  // {
  //   name: "Limited Partnership",
  //   value: "LTDP",
  // },
  // {
  //   name: "Overseas Gov. Int. Organisation, Diplomatic Mission",
  //   value: "OGIO",
  // },
  // {
  //   name: "Partnership",
  //   value: "PART",
  // },
  // {
  //   name: "Private Individual",
  //   value: "IND ",
  // },
  // {
  //   name: "Private Limited Company/Limited Liability Company",
  //   value: "LTD ",
  // },
  // {
  //   name: "Public Limited Company",
  //   value: "PLC ",
  // },
  // {
  //   name: "Religious and/or Faith Body",
  //   value: "REL ",
  // },
  // {
  //   name: "Representative Office of an Overseas Company ",
  //   value: "ROOC",
  // },
  // {
  //   name: "Sole Trader",
  //   value: "SOLE",
  // },
  // {
  //   name: "Unlimited Company",
  //   value: "ULTD",
  // },
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Charity",
    value: "CHAR",
  },
  {
    name: "Private Limited Liability Company",
    value: "LTD ",
  },
  {
    name: "Something else",
    value: "OTHER",
  },
];

export const smsTypeOfBody = [
  // {
  //   name: "- Select -",
  //   value: null,
  // },
  // {
  //   name: "Head Office",
  //   value: "HEADOFF",
  // },
  // {
  //   name: "United Kingdom Branch",
  //   value: "UKBRANCH",
  // },
  // {
  //   name: "Head Office and all United Kingdom Branches",
  //   value: "HEADUKBR",
  // },
  // {
  //   name: "Group of Branches",
  //   value: "GRPBR",
  // },
  // {
  //   name: "Single Body",
  //   value: "SINGENT",
  // },
  // {
  //   name: "Franchise",
  //   value: "FRANCHIS",
  // },
  // {
  //   name: "Subsidiary of a Parent Company",
  //   value: "SUBSID",
  // },
  // {
  //   name: "Parent Company with Subsidiaries",
  //   value: "PCSUBSID",
  // },
  // {
  //   name: "Other",
  //   value: "OTHER",
  // },
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Multiple branch care company",
    value: "HEADUKBR",
  },
  {
    name: "Single branch care company",
    value: "SINGENT",
  },
  {
    name: "Franchise",
    value: "FRANCHIS",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export const smsUkRegion = [
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Wales",
    value: "sponsorapporg2:apply_0",
  },
  {
    name: "Scotland",
    value: "sponsorapporg2:apply_1",
  },
  {
    name: "Northern Ireland",
    value: "sponsorapporg2:apply_2",
  },
  {
    name: "England",
    value: "sponsorapporg2:apply_3",
  },
];

export const smsCountryOptions = [
  {
    name: "- Select -",
    value: null,
  },
  {
    name: "Afghanistan",
    value: "AF ",
  },
  {
    name: "Åland Islands",
    value: "AX ",
  },
  {
    name: "Albania",
    value: "AL ",
  },
  {
    name: "Algeria",
    value: "DZ ",
  },
  {
    name: "American Samoa",
    value: "AS ",
  },
  {
    name: "Andorra",
    value: "AD ",
  },
  {
    name: "Angola",
    value: "AO ",
  },
  {
    name: "Anguilla",
    value: "AI ",
  },
  {
    name: "Antarctica",
    value: "AQ ",
  },
  {
    name: "Antigua And Barbuda",
    value: "AG ",
  },
  {
    name: "Argentina",
    value: "AR ",
  },
  {
    name: "Armenia",
    value: "AM ",
  },
  {
    name: "Aruba",
    value: "AW ",
  },
  {
    name: "Australia",
    value: "AU ",
  },
  {
    name: "Austria",
    value: "AT ",
  },
  {
    name: "Azerbaijan",
    value: "AZ ",
  },
  {
    name: "Bahamas",
    value: "BS ",
  },
  {
    name: "Bahrain",
    value: "BH ",
  },
  {
    name: "Bangladesh",
    value: "BD ",
  },
  {
    name: "Barbados",
    value: "BB ",
  },
  {
    name: "Belarus",
    value: "BY ",
  },
  {
    name: "Belgium",
    value: "BE ",
  },
  {
    name: "Belize",
    value: "BZ ",
  },
  {
    name: "Benin",
    value: "BJ ",
  },
  {
    name: "Bermuda",
    value: "BM ",
  },
  {
    name: "Bhutan",
    value: "BT ",
  },
  {
    name: "Bolivia",
    value: "BO ",
  },
  {
    name: "Bonaire, Sint Eustatius And Saba",
    value: "BQ ",
  },
  {
    name: "Bosnia And Herzegovina",
    value: "BA ",
  },
  {
    name: "Botswana",
    value: "BW ",
  },
  {
    name: "Bouvet Island",
    value: "BV ",
  },
  {
    name: "Brazil",
    value: "BR ",
  },
  {
    name: "British Indian Ocean Territory",
    value: "IO ",
  },
  {
    name: "British Virgin Islands",
    value: "VG ",
  },
  {
    name: "Brunei Darussalam",
    value: "BN ",
  },
  {
    name: "Bulgaria",
    value: "BG ",
  },
  {
    name: "Burkina Faso",
    value: "BF ",
  },
  {
    name: "Burundi",
    value: "BI ",
  },
  {
    name: "Cambodia",
    value: "KH ",
  },
  {
    name: "Cameroon",
    value: "CM ",
  },
  {
    name: "Canada",
    value: "CA ",
  },
  {
    name: "Cape Verde",
    value: "CV ",
  },
  {
    name: "Cayman Islands",
    value: "KY ",
  },
  {
    name: "Central African Republic",
    value: "CF ",
  },
  {
    name: "Chad",
    value: "TD ",
  },
  {
    name: "Chile",
    value: "CL ",
  },
  {
    name: "China",
    value: "CN ",
  },
  {
    name: "Christmas Island",
    value: "CX ",
  },
  {
    name: "Cocos (Keeling) Islands",
    value: "CC ",
  },
  {
    name: "Colombia",
    value: "CO ",
  },
  {
    name: "Comoros",
    value: "KM ",
  },
  {
    name: "Congo",
    value: "CG ",
  },
  {
    name: "Cook Islands",
    value: "CK ",
  },
  {
    name: "Costa Rica",
    value: "CR ",
  },
  {
    name: "Cote D'ivoire (Ivory Coast)",
    value: "CI ",
  },
  {
    name: "Croatia",
    value: "HR ",
  },
  {
    name: "Cuba",
    value: "CU ",
  },
  {
    name: "Cyprus",
    value: "CY ",
  },
  {
    name: "Czech Republic",
    value: "CZ ",
  },
  {
    name: "Democratic People's Republic Of Korea",
    value: "KP ",
  },
  {
    name: "Democratic Republic Of The Congo",
    value: "CD ",
  },
  {
    name: "Denmark",
    value: "DK ",
  },
  {
    name: "Djibouti",
    value: "DJ ",
  },
  {
    name: "Dominica",
    value: "DM ",
  },
  {
    name: "Dominican Republic",
    value: "DO ",
  },
  {
    name: "Ecuador",
    value: "EC ",
  },
  {
    name: "Egypt",
    value: "EG ",
  },
  {
    name: "El Salvador",
    value: "SV ",
  },
  {
    name: "Equatorial Guinea",
    value: "GQ ",
  },
  {
    name: "Eritrea",
    value: "ER ",
  },
  {
    name: "Estonia",
    value: "EE ",
  },
  {
    name: "Ethiopia",
    value: "ET ",
  },
  {
    name: "Falkland Islands",
    value: "FK ",
  },
  {
    name: "Faroe Islands",
    value: "FO ",
  },
  {
    name: "Fiji",
    value: "FJ ",
  },
  {
    name: "Finland",
    value: "FI ",
  },
  {
    name: "France",
    value: "FR ",
  },
  {
    name: "French Guiana",
    value: "GF ",
  },
  {
    name: "French Polynesia",
    value: "PF ",
  },
  {
    name: "Gabon",
    value: "GA ",
  },
  {
    name: "Gambia",
    value: "GM ",
  },
  {
    name: "Georgia",
    value: "GE ",
  },
  {
    name: "Germany",
    value: "DE ",
  },
  {
    name: "Ghana",
    value: "GH ",
  },
  {
    name: "Gibraltar",
    value: "GI ",
  },
  {
    name: "Greece",
    value: "GR ",
  },
  {
    name: "Greenland",
    value: "GL ",
  },
  {
    name: "Grenada",
    value: "GD ",
  },
  {
    name: "Guadeloupe",
    value: "GP ",
  },
  {
    name: "Guam",
    value: "GU ",
  },
  {
    name: "Guatemala",
    value: "GT ",
  },
  {
    name: "Guernsey",
    value: "GG ",
  },
  {
    name: "Guinea",
    value: "GN ",
  },
  {
    name: "Guinea-Bissau",
    value: "GW ",
  },
  {
    name: "Guyana",
    value: "GY ",
  },
  {
    name: "Haiti",
    value: "HT ",
  },
  {
    name: "Heard & Mcdonald Islands",
    value: "HM ",
  },
  {
    name: "Holy See (Vatican City State)",
    value: "VA ",
  },
  {
    name: "Honduras",
    value: "HN ",
  },
  {
    name: "Hong Kong (Sarc)",
    value: "HK ",
  },
  {
    name: "Hungary",
    value: "HU ",
  },
  {
    name: "Iceland",
    value: "IS ",
  },
  {
    name: "India",
    value: "IN ",
  },
  {
    name: "Indonesia",
    value: "ID ",
  },
  {
    name: "Iran (Islamic Republic Of)",
    value: "IR ",
  },
  {
    name: "Iraq",
    value: "IQ ",
  },
  {
    name: "Ireland",
    value: "IE ",
  },
  {
    name: "Isle Of Man",
    value: "IM ",
  },
  {
    name: "Israel",
    value: "IL ",
  },
  {
    name: "Italy",
    value: "IT ",
  },
  {
    name: "Jamaica",
    value: "JM ",
  },
  {
    name: "Japan",
    value: "JP ",
  },
  {
    name: "Jersey",
    value: "JE ",
  },
  {
    name: "Jordan",
    value: "JO ",
  },
  {
    name: "Kazakhstan",
    value: "KZ ",
  },
  {
    name: "Kenya",
    value: "KE ",
  },
  {
    name: "Kiribati",
    value: "KI ",
  },
  {
    name: "Kosovo",
    value: "XK ",
  },
  {
    name: "Kuwait",
    value: "KW ",
  },
  {
    name: "Kyrgyzstan",
    value: "KG ",
  },
  {
    name: "Lao People's Democratic Republic",
    value: "LA ",
  },
  {
    name: "Latvia",
    value: "LV ",
  },
  {
    name: "Lebanon",
    value: "LB ",
  },
  {
    name: "Lesotho",
    value: "LS ",
  },
  {
    name: "Liberia",
    value: "LR ",
  },
  {
    name: "Libya",
    value: "LY ",
  },
  {
    name: "Liechtenstein",
    value: "LI ",
  },
  {
    name: "Lithuania",
    value: "LT ",
  },
  {
    name: "Luxembourg",
    value: "LU ",
  },
  {
    name: "Macao S.A.R. Of China",
    value: "MO ",
  },
  {
    name: "Macedonia, Former Yugoslav Republic",
    value: "MK ",
  },
  {
    name: "Madagascar",
    value: "MG ",
  },
  {
    name: "Malawi",
    value: "MW ",
  },
  {
    name: "Malaysia",
    value: "MY ",
  },
  {
    name: "Maldives",
    value: "MV ",
  },
  {
    name: "Mali",
    value: "ML ",
  },
  {
    name: "Malta",
    value: "MT ",
  },
  {
    name: "Marshall Islands",
    value: "MH ",
  },
  {
    name: "Martinique",
    value: "MQ ",
  },
  {
    name: "Mauritania",
    value: "MR ",
  },
  {
    name: "Mauritius",
    value: "MU ",
  },
  {
    name: "Mayotte",
    value: "YT ",
  },
  {
    name: "Mexico",
    value: "MX ",
  },
  {
    name: "Micronesia (Federated States Of)",
    value: "FM ",
  },
  {
    name: "Monaco",
    value: "MC ",
  },
  {
    name: "Mongolia",
    value: "MN ",
  },
  {
    name: "Montenegro",
    value: "ME ",
  },
  {
    name: "Montserrat",
    value: "MS ",
  },
  {
    name: "Morocco",
    value: "MA ",
  },
  {
    name: "Mozambique",
    value: "MZ ",
  },
  {
    name: "Myanmar",
    value: "MM ",
  },
  {
    name: "Namibia",
    value: "NA ",
  },
  {
    name: "Nauru",
    value: "NR ",
  },
  {
    name: "Nepal",
    value: "NP ",
  },
  {
    name: "Netherlands",
    value: "NL ",
  },
  {
    name: "New Caledonia",
    value: "NC ",
  },
  {
    name: "New Zealand",
    value: "NZ ",
  },
  {
    name: "Nicaragua",
    value: "NI ",
  },
  {
    name: "Niger",
    value: "NE ",
  },
  {
    name: "Nigeria",
    value: "NG ",
  },
  {
    name: "Niue",
    value: "NU ",
  },
  {
    name: "Norfolk Island",
    value: "NF ",
  },
  {
    name: "Northern Mariana Islands",
    value: "MP ",
  },
  {
    name: "Norway",
    value: "NO ",
  },
  {
    name: "Oman",
    value: "OM ",
  },
  {
    name: "Pakistan",
    value: "PK ",
  },
  {
    name: "Palau",
    value: "PW ",
  },
  {
    name: "Palestinian Territory Occupied",
    value: "PS ",
  },
  {
    name: "Panama",
    value: "PA ",
  },
  {
    name: "Papua New Guinea",
    value: "PG ",
  },
  {
    name: "Paraguay",
    value: "PY ",
  },
  {
    name: "Peru",
    value: "PE ",
  },
  {
    name: "Philippines",
    value: "PH ",
  },
  {
    name: "Pitcairn",
    value: "PN ",
  },
  {
    name: "Poland",
    value: "PL ",
  },
  {
    name: "Portugal",
    value: "PT ",
  },
  {
    name: "Puerto Rico",
    value: "PR ",
  },
  {
    name: "Qatar",
    value: "QA ",
  },
  {
    name: "Republic Of Moldova",
    value: "MD ",
  },
  {
    name: "Reunion",
    value: "RE ",
  },
  {
    name: "Romania",
    value: "RO ",
  },
  {
    name: "Russian Federation",
    value: "RU ",
  },
  {
    name: "Rwanda",
    value: "RW ",
  },
  {
    name: "Saint Barthélemy",
    value: "BL ",
  },
  {
    name: "Saint Helena",
    value: "SH ",
  },
  {
    name: "Saint Martin",
    value: "MF ",
  },
  {
    name: "Samoa",
    value: "WS ",
  },
  {
    name: "San Marino",
    value: "SM ",
  },
  {
    name: "Sao Tome And Principe",
    value: "ST ",
  },
  {
    name: "Saudi Arabia",
    value: "SA ",
  },
  {
    name: "Senegal",
    value: "SN ",
  },
  {
    name: "Serbia",
    value: "RS ",
  },
  {
    name: "Seychelles",
    value: "SC ",
  },
  {
    name: "Sierra Leone",
    value: "SL ",
  },
  {
    name: "Singapore",
    value: "SG ",
  },
  {
    name: "Slovakia",
    value: "SK ",
  },
  {
    name: "Slovenia",
    value: "SI ",
  },
  {
    name: "Solomon Islands",
    value: "SB ",
  },
  {
    name: "Somalia",
    value: "SO ",
  },
  {
    name: "South Africa",
    value: "ZA ",
  },
  {
    name: "South Georgia & South Sandwich Islands",
    value: "GS ",
  },
  {
    name: "South Korea (Republic Of Korea)",
    value: "KR ",
  },
  {
    name: "South Sudan",
    value: "SS ",
  },
  {
    name: "Spain",
    value: "ES ",
  },
  {
    name: "Sri Lanka",
    value: "LK ",
  },
  {
    name: "St Kitts & Nevis",
    value: "KN ",
  },
  {
    name: "St Lucia",
    value: "LC ",
  },
  {
    name: "St Pierre & Miquelon",
    value: "PM ",
  },
  {
    name: "St Vincent & The Grenadines",
    value: "VC ",
  },
  {
    name: "Sudan",
    value: "SD ",
  },
  {
    name: "Suriname",
    value: "SR ",
  },
  {
    name: "Svalbard & Jan Mayen Islands",
    value: "SJ ",
  },
  {
    name: "Swaziland",
    value: "SZ ",
  },
  {
    name: "Sweden",
    value: "SE ",
  },
  {
    name: "Switzerland",
    value: "CH ",
  },
  {
    name: "Syria Arab Republic",
    value: "SY ",
  },
  {
    name: "Taiwan",
    value: "TW ",
  },
  {
    name: "Tajikistan",
    value: "TJ ",
  },
  {
    name: "Thailand",
    value: "TH ",
  },
  {
    name: "Timor-Leste",
    value: "TL ",
  },
  {
    name: "Togo",
    value: "TG ",
  },
  {
    name: "Tokelau",
    value: "TK ",
  },
  {
    name: "Tonga",
    value: "TO ",
  },
  {
    name: "Trinidad And Tobago",
    value: "TT ",
  },
  {
    name: "Tunisia",
    value: "TN ",
  },
  {
    name: "Turkey",
    value: "TR ",
  },
  {
    name: "Turkish Controlled Area Of Cyprus",
    value: "XT ",
  },
  {
    name: "Turkmenistan",
    value: "TM ",
  },
  {
    name: "Turks And Caicos Islands",
    value: "TC ",
  },
  {
    name: "Tuvalu",
    value: "TV ",
  },
  {
    name: "Uganda",
    value: "UG ",
  },
  {
    name: "Ukraine",
    value: "UA ",
  },
  {
    name: "United Arab Emirates",
    value: "AE ",
  },
  {
    name: "United Kingdom",
    value: "GB ",
  },
  {
    name: "United Nations",
    value: "UN ",
  },
  {
    name: "United Nations Agency",
    value: "UT ",
  },
  {
    name: "United Republic Of Tanzania",
    value: "TZ ",
  },
  {
    name: "United States Of America",
    value: "US ",
  },
  {
    name: "United States Minor Outlying Islands",
    value: "UM ",
  },
  {
    name: "United States Virgin Islands",
    value: "VI ",
  },
  {
    name: "Uruguay",
    value: "UY ",
  },
  {
    name: "Ussr",
    value: "SU ",
  },
  {
    name: "Uzbekistan",
    value: "UZ ",
  },
  {
    name: "Vanuatu",
    value: "VU ",
  },
  {
    name: "Venezuela",
    value: "VE ",
  },
  {
    name: "Vietnam",
    value: "VN ",
  },
  {
    name: "Wallis And Futuna Islands",
    value: "WF ",
  },
  {
    name: "Western Sahara",
    value: "EH ",
  },
  {
    name: "Yemen",
    value: "YE ",
  },
  {
    name: "Yugoslavia",
    value: "YU ",
  },
  {
    name: "Zambia",
    value: "ZM ",
  },
  {
    name: "Zimbabwe",
    value: "ZW ",
  },
];
